import React from "react";
import { View } from "@react-pdf/renderer";
import { formatMoney } from "../money";
import { styles } from "../styles";
import { OrderTotalEntry } from "./OrderTotalEntry";
import { translate } from "../translate";
import { hideTotals } from "../utils/calculateTotals";

const formatDiscount = (totalAmount, discountedAmount, currency) => {
  const price = formatMoney(discountedAmount, currency);

  if (discountedAmount === 0) {
    return price;
  }

  const discountPercent = (discountedAmount / totalAmount) * 100;

  return `${price} (${discountPercent.toFixed(2)}%)`;
};

export const Totals = ({ order, totals }) => {
  const showTotals = !hideTotals(order);

  if (!totals) return null;
  return (
    <View style={[styles.padTop15]}>
      <OrderTotalEntry
        k={translate("productList.quantity")}
        v={totals.quantitySum}
      />
      {showTotals && (
        <>
          <OrderTotalEntry
            k={translate("productList.sumWithoutRebate", {
              currency: totals.currency,
            })}
            v={formatMoney(totals.totalWithoutRebate, totals.currency)}
          />
          <OrderTotalEntry
            k={translate("productList.sumRebate", {
              currency: totals.currency,
            })}
            v={formatDiscount(
              totals.totalWithoutRebate,
              totals.rebateAmount,
              totals.currency,
            )}
          />
          <OrderTotalEntry
            k={translate("productList.sum", { currency: totals.currency })}
            v={formatMoney(totals.sumWithRebate, totals.currency)}
          />
        </>
      )}
    </View>
  );
};
